import { sendBaseRequest } from '@/assets/public'
import wx from "weixin-js-sdk"
import urlconfig from '@/config.js'
import { sendRequest } from '@/assets/public'

import Vue from "vue";
function GetRequest() {
    var hash = decodeURI(location.hash)
    var history = decodeURI(location.search)
    var theRequest = new Object();
    var str = '', strs;
    if (history && hash) {
        var hashstr = hash.substr(hash.indexOf("?") + 1);
        var historystr = history.substr(history.indexOf("?") + 1);
        str = historystr + "&" + hashstr
    } else {
        var hashstr = hash.substr(hash.indexOf("?") + 1);
        var historystr = history.substr(history.indexOf("?") + 1);
        str = historystr || hashstr

    }
    strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
    return theRequest;
};
class Share {
    constructor(el) {
        // console.log(el)

        this.getData(el)
    }
    async getData(el) {
        let { content, status } = await sendRequest('user/wxShare', {
            url: location.href.split('#')[0]
        })
        // alert(window.localStorage.getItem('store_name') + '' + window.localStorage.getItem('store_logo'))
        if (status != 200) { return }
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: content.appId, // 必填，公众号的唯一标识
            timestamp: content.timestamp + '', // 必填，生成签名的时间戳
            nonceStr: content.nonceStr, // 必填，生成签名的随机串
            signature: content.signature,// 必填，签名，见附录1
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ]
        });
        wx.error(function (res) {
            console.warn('微信 JS-SDK 配置失败', res);
        });
        let urlRequest = GetRequest()
        let surl = window.location.href
        let furl = urlRequest.store_id
        let storeid = furl || window.localStorage.getItem('store_id') || 4326648
        let atter = urlconfig.goPath + '?store_id=' + storeid
        if (surl.indexOf('shopDetail') > -1) {
            atter = urlconfig.goPath + '?store_id=' + storeid + '&value=' + surl.split('id=')[1] + '&key=shopDetail'
            atter = urlconfig.goPath + 'shopDetail?store_id=' + storeid + '&id=' + urlRequest.id
        }
        wx.ready(function () {
            let goodsImage = el && (el.goods_images || el.goods_image);
            let imgUrl = Array.isArray(goodsImage) ? goodsImage[0] : goodsImage;
            let shareInfo = {
                title: (el && el.goods_name) || window.localStorage.getItem('store_name') || document.title, // 分享标题
                desc: '打开积分商城，兑换你喜欢的好物～', // 分享描述
                link: atter, // 分享链接，该链接域名必须与当前企业的可信域名一致'
                imgUrl: imgUrl || window.localStorage.getItem('store_logo') || urlconfig.shareImg, // 分享图标
                success: function () {
                    console.log('微信好友分享配置成功');
                },// 用户确认分享后执行的回调函数
                cancel: function () {
                    console.log('微信好友分享取消');
                },// 用户取消分享后执行的回调函数
                fail: function (res) {
                    console.warn('微信好友分享设置失败', res);
                }
            };
            let timelineShareInfo = {
                title: shareInfo.title,
                link: shareInfo.link,
                imgUrl: shareInfo.imgUrl,
                success: function () {
                    console.log('微信朋友圈分享配置成功');
                },
                cancel: function () {
                    console.log('微信朋友圈分享取消');
                },
                fail: function (res) {
                    console.warn('微信朋友圈分享设置失败', res);
                }
            };

            console.log('微信分享参数', {
                title: shareInfo.title,
                desc: shareInfo.desc,
                link: shareInfo.link,
                imgUrl: shareInfo.imgUrl
            });

            if (typeof wx.updateAppMessageShareData !== 'function' ||
                typeof wx.updateTimelineShareData !== 'function') {
                console.warn('当前微信 JS-SDK 不支持新版分享接口');
                return;
            }

            // 只使用新版分享接口，避免旧接口触发 offline verifying。
            wx.updateAppMessageShareData(shareInfo);
            wx.updateTimelineShareData(timelineShareInfo);
        });
    }
}

export default Share;
